import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import {
  BreadCrumbModel, StepIndicatorService, StepIndicatorModel, GridSortService, PageLoaderService,
  MobilePivotModel, BreadCrumbService
} from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService } from './../../../lib/ng2-sapmp/src/providers';
import { STEPINDICATORS } from './../../../config';
import { SendSMSService } from './send-sms.service';
import { ENV, MOBILEPIVOTS } from 'config';

declare var ENV_VAR: any;

@Component({
  templateUrl: './send-sms.component.html',
  styleUrls: ['./send-sms.component.scss'],
  providers: [StepIndicatorService, SendSMSService, GridSortService]
})

export class SendSMSComponent implements OnInit, OnDestroy {
  public steps: Array<StepIndicatorModel>;
  public pivots: Array<MobilePivotModel>;
  public errorMessage: any;
  private companyId: number;
  currentStep: any;
  constructor(private breadCrumbService: BreadCrumbService,
    private stepIndicator: StepIndicatorService,
    private utilities: UtilityService,
    private messageService: SendSMSService,
    private spinner: PageLoaderService) {
    this.steps = JSON.parse(JSON.stringify(STEPINDICATORS.sendSMS));
    this.errorMessage = {
      'heading': 'Something went wrong.',
      'subHeading': 'Please try again',
      'show': false
    };
   /* messageService.fetchJSON(this.utilities.getEnvConfig().contentUrl.sendSMS.page).subscribe(resObj1 => {
      messageService.setPageJson(resObj1);
    }, err => {
      this.errorMessage.show = true;
      this.spinner.setPageLoaderStatus(true);
    });*/
    this.messageService.getPageError().subscribe(err => {
      if (err.heading) {
        this.errorMessage = Object.assign({ 'show': true }, err);
      } else {
        this.errorMessage.show = false;
      }
    });
  }

  ngOnInit() {
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.label = 'Send a text message';
    breadcrumb.routerLink = '/sendMessage';
    const callingPage = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    const pivots = JSON.parse(JSON.stringify(MOBILEPIVOTS.SMSPAGE));
    this.breadCrumbService.setCurrentBreadCrumb(breadcrumb);
    this.stepIndicator.setCurrentStep('message');
    this.stepIndicator.setVisibility(true);
    if (callingPage === '/deviceInventory') {
      pivots.unshift({ label: 'Device Inventory', routerLink: callingPage });
    } else {
      pivots.unshift({ label: 'Manage Inventory', routerLink: '/manageInventory' });
    }
    this.pivots = pivots;
    this.stepIndicator.getCurrentStep().subscribe(
      (path: string) => {
        this.currentStep = path + ' step';
      });
  }

  ngOnDestroy() {
    this.messageService.removeMessageModel();
  }

  dismissInfo(){
    this.errorMessage.show = false;
  }
}
